export enum FranchisePartnershipModelEnum {
  INDICATOR = 'INDICATOR',
  DEALER = 'DEALER'
}
